"use client";

import { FC, useCallback } from "react";
import { Vehicle } from "@/types/vehicle";
import styles from "./styles.module.scss";
import cx from "classnames";
import FavoriteIcon from "../../../icons/favorite-icon";
import { deleteLikedVehicle, setLikedVehicle, useLikedVehicles } from "@/hooks/useLikes";
import { Translations } from "@/utils/translations";
import { getTranslationModule } from "@/utils/translations";

interface ICardGridProperty {
  vehicle: Vehicle;
  className?: string;
  translations: Translations;
  hideTitle?: boolean;
}

const CarFavoriteButton: FC<ICardGridProperty> = ({ vehicle, className, translations, hideTitle }) => {
  const t = getTranslationModule(translations, "common");
  const likedVehicles = useLikedVehicles();
  const isLiked = likedVehicles.some((item: string) => item === vehicle.id);
  const clickHandler = useCallback(() => {
    if (isLiked) {
      deleteLikedVehicle(vehicle.id);
    } else {
      setLikedVehicle(vehicle.id);
    }
  }, [isLiked, vehicle.id]);

  return (
    <button
      className={cx(styles.like, className, {
        [styles.active]: isLiked,
      })}
      onClick={clickHandler}
      aria-label={"add vehicle to favorites"}
    >
      <FavoriteIcon />
      {!hideTitle && (
        <span className={styles.text}>{isLiked ? t("remove_from_favorites") : t("add_to_favorites")}</span>
      )}
    </button>
  );
};

export default CarFavoriteButton;
